import React, { useContext } from 'react';

import { Button } from 'primereact/button';
import type { Task } from 'types/interfaces';

import { DistributionRowContext } from '../rowContext';

export const ManualAssignCell: React.FC<{ task: Task }> = ({ task }) => {
  const ctx = useContext(DistributionRowContext);
  if (!ctx) return null;
  const taskId = Number(task.id);
  const selected = ctx.manualExecutorsByTaskId[taskId] ?? [];
  const disabled = !selected.length;
  return (
    <Button
      type="button"
      label="Назначить"
      icon="pi pi-user-edit"
      severity={selected.length ? 'success' : 'secondary'}
      disabled={disabled}
      onClick={() => ctx.onManualAssign(task)}
      style={{ height: 40.18, minWidth: 135 }}
    />
  );
};
